import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { DeleteIcon } from "../../../assets/Icons/DeleteIcon";
interface Props{
onDelete: (data: any) => void
}

export const ActionCell = (props: Props & GridCustomCellProps) => {
  const { onDelete, dataItem } = props;
  return (
    <td
      {...props.tdProps}
      onClick={() => onDelete(dataItem)}
      style={{ cursor: "pointer" }}
    >
      <DeleteIcon />
    </td>
  );
};